import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0E58D8",
      d: "m13 .613 11.83 7.012q.211.177.353.407a.96.96 0 0 1 .142.514v14.237q0 .921-.602 1.523t-1.523.602H2.8q-.921 0-1.523-.602t-.602-1.523V8.546a.96.96 0 0 1 .142-.514 1.7 1.7 0 0 1 .354-.407zm0 14.308 11.05-6.588L13 1.746 1.95 8.333z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "email"}) } }